import { fetchApi } from "../../tools";

const getCursosAsignadosAlumno = async (urlCursos, headers, carnet) => {

    try {
        const response = await fetchApi({
            url: urlCursos + '/utils/busquedas',
            headers: headers,
            content: {
                "Opcion": "CURSOS_ALUMNO",
                "Carnet": carnet.Carnet,
                "Modalidad": carnet.Modalidad
            }
        })
        return await response.msg
    } catch (error) {
        return await error
    }
}

export { getCursosAsignadosAlumno };
